import { useTranslation } from "@refinedev/core";

import { Box, Stack, Typography } from "@mui/material";

import MaskGroup from "@/assets/images/mask-group.svg";
import VitallFullLogo from "@/assets/images/vitall-white-red-full-logo.svg";

export const UnauthFooterCorner = () => {
  const { translate } = useTranslation();

  return (
    <Box
      position="absolute"
      bottom={0}
      right={0}
      width={550}
      height={200}
      overflow="hidden"
      sx={{ pointerEvents: "none" }}
    >
      {/* Background mask shape */}
      <Box component="img" src={MaskGroup} alt="" display="block" width={1000} height="auto" />

      {/* "Powered by" + VITALL logo overlay */}
      <Stack position="absolute" bottom={2.5} right={3} alignItems="flex-start" zIndex={2}>
        <Typography variant="caption" color="common.white">
          {translate("pages.login.poweredBy", "Powered by")}
        </Typography>
        <Box
          component="img"
          src={VitallFullLogo}
          alt="VITALL"
          width={{ xs: 100, sm: 150 }}
          height="auto"
          mb={4}
          mr={4}
        />
      </Stack>
    </Box>
  );
};
